/**
 * BadgeRuoli — un riquadro per OGNI ruolo del giocatore, ciascuno col suo
 * colore (Andrea 2026-10-22: «TQ/CC» era un solo riquadro tutto viola; il
 * trequartista e' viola ma il centrocampista e' azzurro). Di default i
 * riquadri sono staccati, come nel catalogo giocatori (panchina, titolari);
 * con `unito` diventano un blocco unico a segmenti attaccati, ogni segmento
 * col suo colore (Andrea 2026-10-22: solo per il recap sotto il campo).
 *
 * Senza ruoli Pro si mostra la lettera Classic (P/D/C/A) col colore del
 * gruppo; senza niente, un "?" grigio.
 */

import { siglaRuolo } from "./nomenclatura";
import { ruoloMantraClass } from "./ruoliMantra";

const CLASSIC_COLORE: Record<string, string> = {
  P: "Por",
  D: "Dc",
  C: "C",
  A: "A",
};

interface BadgeRuoliProps {
  ruoli: ReadonlyArray<string> | null | undefined;
  classic?: string | null;
  /** xs = 8px (card compatte), sm = 9px (righe). */
  size?: "xs" | "sm";
  className?: string;
  title?: string;
  /** Blocco unico a segmenti attaccati invece di riquadri staccati. */
  unito?: boolean;
}

export function BadgeRuoli({
  ruoli,
  classic,
  size = "xs",
  className = "",
  title,
  unito = false,
}: BadgeRuoliProps) {
  const testo = size === "xs" ? "text-[8px]" : "text-[9px]";
  const lista = ruoli && ruoli.length > 0 ? [...ruoli] : [];
  if (lista.length === 0) {
    const lettera = classic ?? "?";
    return (
      <span
        className={`font-mono ${testo} font-bold px-1 rounded shrink-0 ${ruoloMantraClass(
          CLASSIC_COLORE[lettera] ?? "",
        )} ${className}`}
      >
        {lettera}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex shrink-0 ${unito ? "" : "flex-wrap gap-1"} ${className}`}
      title={title}
    >
      {lista.map((r, i) => (
        <span
          key={`${r}-${i}`}
          className={`font-mono ${testo} font-bold px-1 ${ruoloMantraClass(r)} ${
            unito
              ? `${i === 0 ? "rounded-l" : ""} ${i === lista.length - 1 ? "rounded-r" : ""}`
              : "rounded"
          }`}
        >
          {siglaRuolo(r)}
        </span>
      ))}
    </span>
  );
}
